import { Box, ModalBody } from '@dixa/lib-shared-habla';

import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioSelectors } from '../../../elevio.reducer/selectors';

import {
  ResolutionArticleSelect,
  ResolutionArticleSolveDialog,
  ResolutionCancelWarning,
  ResolutionDraftDialog,
  ResolutionProgressBar,
} from './index';

type ResolutionModalBodyWrapperProps = {
  children: React.ReactNode;
};
function ResolutionModalBodyWrapper({
  children,
}: ResolutionModalBodyWrapperProps) {
  const stage = useAppSelector(elevioSelectors.resolution.stage);
  const sideMargins = 32 + 32;
  const modalWidth = 512 - sideMargins; // minus side margins

  return (
    <ModalBody>
      <ResolutionProgressBar stage={stage} />
      <Box width={`${modalWidth}px`}>{children}</Box>
    </ModalBody>
  );
}

export function ResolutionModalBody(): JSX.Element {
  const stage = useAppSelector(elevioSelectors.resolution.stage);

  if (stage === 'cancelWarning') {
    return (
      <ResolutionModalBodyWrapper>
        <ResolutionCancelWarning />
      </ResolutionModalBodyWrapper>
    );
  }

  return (
    <ResolutionModalBodyWrapper>
      <ResolutionArticleSolveDialog />
    </ResolutionModalBodyWrapper>
  );
}

export function ArticleOrDraftSelector(): JSX.Element | null {
  const articleSolved = useAppSelector(
    elevioSelectors.resolution.articleSolved,
  );

  if (articleSolved) {
    return <ResolutionArticleSelect />;
  }
  if (articleSolved === false) {
    return <ResolutionDraftDialog />;
  }
  /** ArticleSolved is undefined */
  return null;
}
